import React, { useCallback, useState } from 'react';
import { Card } from 'antd';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import { CalendarEvents } from './CalendarEvents';
import { AddAppointmentModal } from './modals/AddAppointmentModal'

const localizer = momentLocalizer(moment);

const AppointmentSchedular = () => {
    const [ visible, setVisible ] = useState(false)
    const [ edititem, setEditItem ] = useState(null)
  
    const today = moment(); // Today’s date
const [myEvents, setMyEvents] = useState([
  {
    id: 1,
    start: today.clone().hour(10).minute(0).toDate(),
    end: today.clone().hour(11).minute(0).toDate(),
    title: 'Initial Consultation – Hair Transplant',
    status: 'completed',
    time: [{ innertime: '11:00' }, { innertime: '15:00' }],
  },
  {
    id: 2,
    start: today.clone().add(1, 'day').hour(10).minute(0).toDate(),
    end: today.clone().add(1, 'day').hour(11).minute(0).toDate(),
    title: 'Graft Extraction Session',
    status: 'progress',
    time: [{ innertime: '11:00' }],
  },
  {
    id: 3,
    start: today.clone().add(2, 'day').hour(10).minute(0).toDate(),
    end: today.clone().add(2, 'day').hour(11).minute(0).toDate(),
    title: 'Hairline Design & Planning',
    status: 'cancel',
    time: [{ innertime: '11:00' }, { innertime: '14:00' }],
  },
  {
    id: 4,
    start: today.clone().add(3, 'day').hour(10).minute(0).toDate(),
    end: today.clone().add(3, 'day').hour(11).minute(0).toDate(),
    title: 'Follow-up & Recovery Check',
    status: 'new',
    time: [{ innertime: '11:00' }, { innertime: '15:00' }],
  },
]);


  
    const moveEvent = useCallback(
        ({ event, start, end, isAllDay: droppedOnAllDaySlot = false }) => {
        const { allDay } = event;
        if (!allDay && droppedOnAllDaySlot) {
            event.allDay = true;
        }
        if (allDay && !droppedOnAllDaySlot) {
            event.allDay = false;
        }

        setMyEvents((prev) =>
            prev.map((ev) =>
            ev.id === event.id ? { ...ev, start, end, allDay: event.allDay } : ev
            )
        );
        },
        [setMyEvents]
    );

  const handleSelectSlot = () => {
    setVisible(true);
  };

  return (
    <div>
      <Card className='radius-12 border0'>
        <Calendar
          localizer={localizer}
          events={myEvents}
          startAccessor="start"
          endAccessor="end"
          style={{ height: 500 }}
          views={['month', 'week', 'day']}
          draggableAccessor={(event) => true}
          onEventDrop={moveEvent}
          selectable
          components={{
            event: (eventProps) => (
              <CalendarEvents
                event={eventProps.event}
                title={eventProps.title}
                setVisible={setVisible}
                setEditItem={setEditItem}
              />
            ),
          }}
          onSelectSlot={handleSelectSlot}
          formats={{
            monthHeaderFormat: (date) => moment(date).format('DD MMMM YYYY'),
          }}
          className='dashboard-calendar'
        />
      </Card>

      <AddAppointmentModal 
        visible={visible}
        edititem={edititem}
        onClose={()=>{setVisible(false);setEditItem(null)}}
      />
    </div>
  );
};

export { AppointmentSchedular };
